import {css} from 'lit';
export const styles = css`:host {
  display: block;
  margin-bottom: 16px;
}

.truncated {
  position: relative;
  margin-bottom: 8px;
  overflow: hidden;
}

.truncated::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 64px;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) 0%,
    var(--contrast-light) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) 0%,
    var(--contrast-light) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) 0%,
    var(--mask-color, var(--contrast-light)) 100%
  );
  border-bottom: 1px dashed #ddd;
  border-bottom: var(--btn-divider, 1px dashed #ddd);
}

button {
  width: 100%;
  padding: 0;
  border: none;
  background: transparent;
  text-align: right;
  text-align: var(--btn-align, right);
  color: var(--link-text);
}

@media (hover: hover) {
    button:hover {
      color: var(--link-text-hover);
    }
  }
`;
export default styles;
